/**
 * 색상 문자열을 rgba 형식으로 변환합니다.
 * @param color - hex, rgb, rgba, rgb(var(...)) 형식의 색상 문자열
 * @param alpha - 투명도 (0~1). rgba 입력 시에는 무시되고 원본 alpha가 유지됩니다.
 */
export function colorToRgba(color: string, alpha = 1): string {
  // rgba 로 들어오는 경우 alpha 가 이미 있다고 가정하기 때문에 그대로 반영합니다.
  if (color.startsWith('rgba(')) {
    return color;
  }

  // rgb 안에 var 변수를 사용하는 경우
  const rgbVarMatch = color.match(/^rgb\((var\(.+\))\)$/);
  if (rgbVarMatch) {
    if (alpha === 1) {
      return color;
    }
    return `rgb(${rgbVarMatch[1]} / ${Math.round(alpha * 10000) / 100}%)`;
  }

  // rgb 로 시작하고 (0, 0, 0) or (0 0 0) 받는 경우
  const rgbMatch = color.match(/^rgb\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)\s*\)$/);
  if (rgbMatch) {
    return `rgba(${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}, ${alpha})`;
  }

  // 그 외 hex 로 들어오는 경우
  const cleaned = color.replace('#', '');
  const expanded =
    cleaned.length === 3
      ? cleaned
          .split('')
          .map(c => c + c)
          .join('')
      : cleaned;

  const r = Number.parseInt(expanded.slice(0, 2), 16);
  const g = Number.parseInt(expanded.slice(2, 4), 16);
  const b = Number.parseInt(expanded.slice(4, 6), 16);

  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return color;
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
